import React from 'react';

import {
  PARTNER_WITH_US_SUBMITTED_HEADER,
  SUCCESSFUL_MESSAGE,
  FOUNDER_DIRECTLY,
} from '../../constants/Pages/PartnerWithUs';

export const SubmittedPartner = () => {
  return (
    <div className="submitted-partner-with-us-wrapper">
      <img
        src="https://cdn-icons-png.freepik.com/512/7390/7390035.png"
        className="partner-submitted-img"
      />
      <h1 className="partner-form-submitted">{PARTNER_WITH_US_SUBMITTED_HEADER}</h1>
      <div className="partner-form-submitted">
        <p>{SUCCESSFUL_MESSAGE}</p>
        <p>{FOUNDER_DIRECTLY}</p>
      </div>
    </div>
  );
};
